module.exports = __webpack_public_path__ + "static/media/C-100HD_CrossSection.690a66d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/PDFReport/es/C-100HD_CrossSection.png
// module id = 2989
// module chunks = 0